import React from 'react'
import styled from 'styled-components'

import { downloadFile } from '../DownloadFile'
import {
  ContentWrapper,
  dropdownItemStyles,
  IconWrapper,
} from './Item/DropdownItem.styles'
import { ListItem } from './Item/DropdownItem'

const DropdownDownloadButton = styled.button`
  ${dropdownItemStyles}
`

export const DropdownDownload = ({
  icon,
  children,
  href,
  onClick,
  ...props
}: OmitSafe<React.ComponentPropsWithoutRef<'button'>, 'type'> & {
  icon?: React.ReactNode
  href?: string
}) => (
  <ListItem>
    <DropdownDownloadButton
      type="button"
      data-unmountafterclick
      onClick={e => {
        onClick?.(e)
        downloadFile(href ?? '')
      }}
      {...props}
    >
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <ContentWrapper>{children}</ContentWrapper>
    </DropdownDownloadButton>
  </ListItem>
)
